import { Routes } from "@angular/router";

import { ClientResolve } from "../../../common/services/client.resolve";
import { LoginComponent } from "./login.component";
import { ForgotPasswordComponent } from "../forgot-password/forgot-password.component";
import { VerifyCodeComponent } from "../verify-code/verify-code.component";

export const rootRouterConfig: Routes = [
    { path: "", component: LoginComponent, resolve: { client: ClientResolve } },
    { path: "forgot-password", component: ForgotPasswordComponent, resolve: { client: ClientResolve } },
    { path: "verify-code", component: VerifyCodeComponent, resolve: { client: ClientResolve } },
    { path: "**", redirectTo: "" },
];
